document.addEventListener("DOMContentLoaded", () => {
    const createLogoSwiper = (selector, reverse = false) => {
        return new Swiper(selector, {
            spaceBetween: 20,
            grabCursor: true,
            a11y: false,
            freeMode: true,
            speed: 11000,
            loop: true,
            centeredSlides: true,
            slidesPerView: 8,
            autoplay: {
                delay: 0,
                enabled: true,
                disableOnInteraction: false,
                reverseDirection: reverse,
            },
        });
    };
    createLogoSwiper('.logo-row1', false);
    createLogoSwiper('.logo-row2', true);
});


const tabButtons = document.querySelectorAll('.tab-btn');
const buttons = document.querySelectorAll('.tab-btn');
const panels = document.querySelectorAll('.tab-panel');

buttons.forEach(btn => {
  btn.addEventListener('click', () => {
    const target = btn.dataset.tab;

    // Buttons
    buttons.forEach(b => {
      b.classList.remove('bg-black', 'text-white', 'border-black');
      b.classList.add('hover:bg-gray-100');
    });

    btn.classList.add('bg-black', 'text-white', 'border-black');
    btn.classList.remove('hover:bg-gray-100');

    // Panels
    panels.forEach(panel => {
      const isActive = panel.id === target;

      panel.classList.toggle('opacity-100', isActive);
      panel.classList.toggle('translate-y-0', isActive);
      panel.classList.toggle('pointer-events-auto', isActive);

      panel.classList.toggle('opacity-0', !isActive);
      panel.classList.toggle('translate-y-4', !isActive);
      panel.classList.toggle('pointer-events-none', !isActive);
    });
  });
});
document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(".accordion-details");
  accordions.forEach((details) => {
      const summary = details.querySelector("summary");
      const content = details.querySelector(".accordion-details__content");
      const baseHeight =
          summary.offsetHeight +
          parseInt(getComputedStyle(details).paddingTop) +
          parseInt(getComputedStyle(details).paddingBottom);
      details.dataset.baseHeight = baseHeight;
      if (!details.hasAttribute("open")) {
          details.style.height = baseHeight + "px";
          content.style.opacity = 0;
          content.style.pointerEvents = "none";
      }

      summary.addEventListener("click", (e) => {
          e.preventDefault();

          if (!details.hasAttribute("open")) {
              accordions.forEach((other) => {
                  if (other !== details && other.hasAttribute("open")) {
                      const otherContent = other.querySelector(".accordion-details__content");
                      closeAccordion(other, otherContent);
                  }
              });
          }

          if (details.hasAttribute("open")) {
              closeAccordion(details, content);
          } else {
              openAccordion(details, content);
          }
      });

  });

  function openAccordion(details, content) {
      const base = parseInt(details.dataset.baseHeight);
      const contentHeight = content.scrollHeight;

      details.setAttribute("open", "");
      details.setAttribute("aria-expanded", "true");
      details.style.height = base + "px";

      content.style.opacity = 0;
      content.style.pointerEvents = "none";

      requestAnimationFrame(() => {
          details.style.transition = "height 0.25s ease";
          content.style.transition = "opacity 0.2s ease";

          details.style.height = base + contentHeight + "px";
          content.style.opacity = 1;
          content.style.pointerEvents = "auto";
      });

      details.addEventListener("transitionend", function handler(e) {
          if (e.propertyName === "height") {
              details.style.height = "auto";
              details.removeEventListener("transitionend", handler);
          }
      });
  }

  function closeAccordion(details, content) {
      const base = parseInt(details.dataset.baseHeight);
      const fullHeight = details.scrollHeight;

      details.style.height = fullHeight + "px";
      details.setAttribute("aria-expanded", "false");

      requestAnimationFrame(() => {
          details.style.transition = "height 0.25s ease";
          content.style.transition = "opacity 0.2s ease";

          details.style.height = base + "px";
          content.style.opacity = 0;
          content.style.pointerEvents = "none";
      });

      details.addEventListener("transitionend", function handler(e) {
          if (e.propertyName === "height") {
              details.removeAttribute("open");
              details.removeEventListener("transitionend", handler);
          }
      });
  }
});

(function () {
    const second = 1000, minute = second * 60, hour = minute * 60;
    const DURATION = 3 * hour;
    const todayKey = new Date().toISOString().split('T')[0];
    const STORAGE_KEY = `daily_countdown_${todayKey}`;
  
    let countdownEnd = localStorage.getItem(STORAGE_KEY);
    if (!countdownEnd) {
      countdownEnd = Date.now() + DURATION;
      localStorage.setItem(STORAGE_KEY, countdownEnd);
    } else {
      countdownEnd = parseInt(countdownEnd, 10);
    }
  
    function flip(cardId, newValue) {
      const card = document.getElementById(cardId);
      if (!card) return;
  
      const topHalf = card.querySelector(".top");
      const bottomHalf = card.querySelector(".bottom");
      const startValue = topHalf.innerText;
  
      if (newValue === startValue) return;
  
      const topFlip = document.createElement("div");
      topFlip.classList.add("top-flip");
      topFlip.innerText = startValue;
  
      const bottomFlip = document.createElement("div");
      bottomFlip.classList.add("bottom-flip");
      bottomFlip.innerText = newValue;
  
      topFlip.addEventListener("animationstart", () => {
        topHalf.innerText = newValue;
      });
  
      bottomFlip.addEventListener("animationend", () => {
        bottomHalf.innerText = newValue;
        topFlip.remove();
        bottomFlip.remove();
      });
  
      card.appendChild(topFlip);
      card.appendChild(bottomFlip);
    }
  
    const timer = setInterval(() => {
      const now = Date.now();
      const distance = countdownEnd - now;
  
      if (distance <= 0) {
        clearInterval(timer);
        document.getElementById("countdown").classList.add("hidden");
        document.getElementById("expired-message").classList.remove("hidden");
        return;
      }
  
      const h = Math.floor(distance / hour).toString().padStart(2, '0');
      const m = Math.floor((distance % hour) / minute).toString().padStart(2, '0');
      const s = Math.floor((distance % minute) / second).toString().padStart(2, '0');
  
      flip("hours-card", h);
      flip("minutes-card", m);
      flip("seconds-card", s);
    }, 1000);
  })();